<template>
  <b-container style="text-align: left">
    <b-modal id="modal-1" title="提示" ok-only no-stacking>
      <p class="my-4">{{ resultPrompt }}</p>
    </b-modal>
    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>
    <b-row>
      <b-col lg="6" xl="6" sm="12" md="6">
        <b-card title="联系方式" img-src="../../statics/about-me.jpg" img-alt="Image" img-top>
          <b-card-text style="margin-top: 5px">地址：共享航次计划指导专家组工作办公室</b-card-text>
          <b-card-text style="margin-top: 5px">联系人：林老师</b-card-text>
          <b-card-text style="margin-top: 5px">电话：0592-2880163</b-card-text>
          <b-card-text style="margin-top: 5px">邮箱：shanshanlin@xmu.edu.cn</b-card-text>
        </b-card>
      </b-col>

      <b-col lg="6" xl="6" sm="12" md="6">
        <b-card title="意见反馈" sub-title="网站新版上线，请提出您宝贵的意见">
          <b-form @submit="onSubmit">
            <b-form-group id="fieldset-1" label="姓名/昵称" label-for="input-1" class="mt20">
              <b-form-input id="input-1" v-model="form.nickname" type="text"></b-form-input>
              <!--placeholder="请输入您的姓名"-->
            </b-form-group>

            <b-form-group id="fieldset-2" label="您的电话" label-for="input-2">
              <b-form-input id="input-2" v-model="form.mobile" type="text"></b-form-input>
              <!--placeholder="请输入您的电话"-->
            </b-form-group>

            <b-form-group id="fieldset-3" label="您的联系地址" label-for="input-3">
              <b-form-input id="input-3" v-model="form.address" type="text"></b-form-input>
              <!--placeholder="请输入您的联系地址"-->
            </b-form-group>

            <b-form-group id="fieldset-4" label="您的邮箱" label-for="input-4">
              <b-form-input id="input-4" v-model="form.email" type="email"></b-form-input>
              <!--placeholder="请输入您的邮箱"-->
            </b-form-group>

            <b-form-group label="意见建议">
              <b-form-textarea v-model="form.opinion" required class="form-control" rows="4"></b-form-textarea>
            </b-form-group>

            <!-- <b-button variant="primary" @click='onSubmit()' style="float: right;padding-left: 20px;padding-right: 20px">提交
            </b-button>-->
            <b-button variant="primary" type="submit" style="float: right; padding-left: 20px; padding-right: 20px"
              >提交</b-button
            >
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  components: {
    LinkComponent,
  },
  // name: "about",
  props: {},
  computed: {},
  data() {
    return {
      resultPrompt: '',
      bread: [
        {
          text: '首页',
          href: '/index',
        },
        {
          text: '关于我们',
        },
      ],
      form: {
        nickname: '',
        mobile: '',
        address: '',
        email: '',
        opinion: '',
      },
      texts: [
        {
          content: '地址：共享航次计划指导专家组工作办公室',
        },
        {
          content: '联系人：叶老师',
        },
        {
          content: '邮箱：shanshanlin@xmu.edu.cn',
        },
      ],
    };
  },
  //       computed: {
  // },
  methods: {
    //表单提交
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.form.opinion) {
        alert('意见必须填写哟');
        return;
      }
      axiosServer({
        url: urls.opinion,
        params: this.form,
        type: 'post',
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            this.showMsg('提交成功');
            this.form = {
              nickname: '',
              mobile: '',
              address: '',
              email: '',
              opinion: '',
            };
          } else {
            this.showMsg('提交失败');
          }
        })
        .catch((e) => {
          this.showMsg('提交失败');
        });
    },
    showMsg(msg) {
      // console.log('show msg');
      this.resultPrompt = msg;
      this.$bvModal.show('modal-1');
    },
  },
};
</script>

<style scoped>
</style>
